<template>
  <social-proof class="es" :class="{ desktop: $isDesktop }">
    <template #press>
      <div class="press">
        <img
          src="@/assets/homepage/press/el-pais.svg"
          loading="lazy"
          alt="El Pais"
          width="132"
          height="30"
        />
        <img
          src="@/assets/homepage/press/el-mundo.svg"
          loading="lazy"
          alt="El Mundo"
          width="223"
          height="30"
        />
        <img
          src="@/assets/homepage/press/la-razon.svg"
          loading="lazy"
          alt="La Razon"
          width="193"
          height="30"
        />
        <template v-if="$isDesktop">
          <img
            src="@/assets/homepage/press/abc.svg"
            loading="lazy"
            alt="ABC"
            width="40"
            height="40"
          />
          <img
            src="@/assets/homepage/press/vogue.svg"
            loading="lazy"
            alt="Vogue"
            width="119"
            height="31"
          />
          <img
            src="@/assets/homepage/press/national-geographic.svg"
            loading="lazy"
            alt="National Geographic"
            width="119"
            height="35"
          />
        </template>
      </div>
    </template>
  </social-proof>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'
import SocialProof from './SocialProof.vue'

@Component({
  mixins: [SocialProof],
})
class SocialProofEs extends Vue {}

export default toNative(SocialProofEs)
</script>
<style scoped>
.es:not(.desktop) .press {
  grid-template-columns: auto;
  grid-template-rows: auto auto auto;
  column-gap: 0;
  row-gap: 0.4em;
}

.es:not(.desktop) .press img {
  max-height: 1em;
  max-width: 6em;
}

.es .press img:first-of-type {
  grid-row: unset;
  grid-column: unset;
  margin: 0;
}

/* mobile landscape */
@media screen and (min-width: 320px) and (max-width: 998px) and (orientation: landscape) {
  .es:not(.desktop) .press {
    grid-template-columns: repeat(3, auto);
    grid-template-rows: auto;
    column-gap: 0.75em;
  }

  .es:not(.desktop) .press img:first-of-type {
    grid-row: unset;
    grid-column: unset;
  }
}
</style>
